import React from 'react';
import Layout from '../components/Layout';
import GlobalAuthorizationLayout from '../components/GlobalAuthorizationLayout';
import Applications from '../apps/Applications';
import CheckStaffUserLayout from '../layout/CheckStaffUserLayout';

const SportsmanSchedulePage: React.FC = () => {
    return (
        <GlobalAuthorizationLayout>
            <CheckStaffUserLayout>
                <Layout>
                    <Applications/>
                </Layout>
            </CheckStaffUserLayout>
        </GlobalAuthorizationLayout>
    );
};

export default SportsmanSchedulePage;
